// ============================================================
// theme.js — Theme system for TestItNow
// Themes: light, dark, ocean, forest, sunset
// ============================================================

export const THEMES = {
  light: {
    name: 'Light',
    icon: '☀️',
    bg:         '#f8fafc',
    bgAlt:      '#ffffff',
    bgCard:     '#ffffff',
    bgHover:    '#f1f5f9',
    sidebar:    '#ffffff',
    panel:      '#f8fafc',
    border:     'rgba(0,0,0,0.08)',
    borderAcc:  'rgba(0,179,140,0.4)',
    text:       '#0f172a',
    textSub:    '#475569',
    textMuted:  '#94a3b8',
    accent:     '#00b38c',
    accentDim:  'rgba(0,179,140,0.1)',
    accentText: '#00b38c',
    blue:       '#2563eb',
    shadow:     '0 1px 3px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)',
    shadowHover:'0 4px 20px rgba(0,0,0,0.12)',
    inputBg:    '#f8fafc',
    navBg:      'rgba(255,255,255,0.95)',
    cardBorder: '1px solid rgba(0,0,0,0.08)',
  },
  dark: {
    name: 'Dark',
    icon: '🌙',
    bg:         '#0a0f1e',
    bgAlt:      '#0d1530',
    bgCard:     '#111b3a',
    bgHover:    '#1a2545',
    sidebar:    '#0d1530',
    panel:      '#0f1a35',
    border:     'rgba(0,212,170,0.12)',
    borderAcc:  'rgba(0,212,170,0.4)',
    text:       '#f0f4ff',
    textSub:    '#94a3b8',
    textMuted:  '#6b7fa3',
    accent:     '#00d4aa',
    accentDim:  'rgba(0,212,170,0.12)',
    accentText: '#00d4aa',
    blue:       '#3b82f6',
    shadow:     '0 4px 24px rgba(0,0,0,0.4)',
    shadowHover:'0 8px 40px rgba(0,0,0,0.5)',
    inputBg:    '#0a0f1e',
    navBg:      'rgba(13,21,48,0.95)',
    cardBorder: '1px solid rgba(0,212,170,0.12)',
  },
  ocean: {
    name: 'Ocean',
    icon: '🌊',
    bg:         '#f0f7ff',
    bgAlt:      '#ffffff',
    bgCard:     '#ffffff',
    bgHover:    '#e8f2ff',
    sidebar:    '#ffffff',
    panel:      '#f0f7ff',
    border:     'rgba(37,99,235,0.12)',
    borderAcc:  'rgba(37,99,235,0.4)',
    text:       '#0c1a3a',
    textSub:    '#1e40af',
    textMuted:  '#60a5fa',
    accent:     '#2563eb',
    accentDim:  'rgba(37,99,235,0.1)',
    accentText: '#1d4ed8',
    blue:       '#0ea5e9',
    shadow:     '0 1px 3px rgba(37,99,235,0.1), 0 4px 16px rgba(37,99,235,0.06)',
    shadowHover:'0 4px 20px rgba(37,99,235,0.15)',
    inputBg:    '#f0f7ff',
    navBg:      'rgba(255,255,255,0.95)',
    cardBorder: '1px solid rgba(37,99,235,0.1)',
  },
  forest: {
    name: 'Forest',
    icon: '🌿',
    bg:         '#f0faf4',
    bgAlt:      '#ffffff',
    bgCard:     '#ffffff',
    bgHover:    '#e6f6ec',
    sidebar:    '#ffffff',
    panel:      '#f0faf4',
    border:     'rgba(22,163,74,0.12)',
    borderAcc:  'rgba(22,163,74,0.4)',
    text:       '#052e16',
    textSub:    '#166534',
    textMuted:  '#4ade80',
    accent:     '#16a34a',
    accentDim:  'rgba(22,163,74,0.1)',
    accentText: '#15803d',
    blue:       '#0d9488',
    shadow:     '0 1px 3px rgba(22,163,74,0.1), 0 4px 16px rgba(22,163,74,0.06)',
    shadowHover:'0 4px 20px rgba(22,163,74,0.15)',
    inputBg:    '#f0faf4',
    navBg:      'rgba(255,255,255,0.95)',
    cardBorder: '1px solid rgba(22,163,74,0.1)',
  },
  sunset: {
    name: 'Sunset',
    icon: '🌅',
    bg:         '#fff7f0',
    bgAlt:      '#ffffff',
    bgCard:     '#ffffff',
    bgHover:    '#fff0e6',
    sidebar:    '#ffffff',
    panel:      '#fff7f0',
    border:     'rgba(234,88,12,0.12)',
    borderAcc:  'rgba(234,88,12,0.4)',
    text:       '#431407',
    textSub:    '#9a3412',
    textMuted:  '#fb923c',
    accent:     '#ea580c',
    accentDim:  'rgba(234,88,12,0.1)',
    accentText: '#c2410c',
    blue:       '#db2777',
    shadow:     '0 1px 3px rgba(234,88,12,0.1), 0 4px 16px rgba(234,88,12,0.06)',
    shadowHover:'0 4px 20px rgba(234,88,12,0.15)',
    inputBg:    '#fff7f0',
    navBg:      'rgba(255,255,255,0.95)',
    cardBorder: '1px solid rgba(234,88,12,0.1)',
  },
};

export const DEFAULT_THEME = 'light';

export function getTheme(name) {
  return THEMES[name] || THEMES.light;
}
